import AccountStore from './account-store';
import DocumentsUploadStore from './documents-upload-store';
import FeaturesStore from './features-store';
import PDFAnnotationsStore from './pdf-annotations-store';
import RequestPacketAccessStore from './request-packet-access-store';
import RouterStore from './router-store';
import SharedPacketsStore from './shared-packets-store';
import SignaturePacketsStore from './signature-packets-store';
import UIStore from './ui-store';
import publicApi from 'src/api';
import { action, makeObservable } from 'mobx';
import routes from '../entries/public/routes';

export class PublicStore {
  appName = 'public';

  constructor({
    Router,
    Ui,
    SharedPackets,
    Account,
    RequestPacketAccess,
    Uploads,
    Features,
    SignaturePackets,
    PDFAnnotations,
    api,
  }) {
    makeObservable(this);
    this.api = api;
    this.router = Router && new Router(this, routes);
    this.ui = Ui && new Ui(this);
    this.uploads = Uploads;
    this.sharedPackets = SharedPackets && new SharedPackets(this);
    this.requestPacketAccess =
      RequestPacketAccess && new RequestPacketAccess(this);
    this.account = Account && new Account(this);
    this.features = Features && new Features(this);
    this.signaturePackets = SignaturePacketsStore && new SignaturePackets(this);
    this.annotations = PDFAnnotations && new PDFAnnotations(this);
    this.initialized = false;
  }

  startSpinning() {
    // deprecated
    this.ui.startSpinning();
  }

  stopSpinning() {
    // deprecated
    this.ui.stopSpinning();
  }

  @action
  forceStopSpinning() {
    // deprecated
    this.ui.forceStopSpinning();
  }

  @action
  initialize(options) {
    if (this.initialized) {
      return;
    }

    this.options = options;
    this.account.initialize(options);
    this.features.initialize();
    this.env = this.options.env;
    this.debug = this.options.debug;
    this.initialized = true;
  }

  handleError() {
    alert('Oops! Something went wrong.'); // eslint-disable-line
  }

  handleNotFoundError() {
    this.handleFatalError("Couldn't find what you were looking for.");
  }

  handleFatalError(message) {
    if (message) {
      this.ui.toast({
        message,
        type: 'error',
      });
    } else {
      this.ui.wentWrong();
    }
  }

  logOut() {
    this.account.logOut();
  }
}

export const subStores = {
  Router: RouterStore,
  Ui: UIStore,
  Account: AccountStore,
  SharedPackets: SharedPacketsStore,
  RequestPacketAccess: RequestPacketAccessStore,
  Features: FeaturesStore,
  SignaturePackets: SignaturePacketsStore,
  Uploads: DocumentsUploadStore,
  PDFAnnotations: PDFAnnotationsStore,
};

export default new PublicStore({
  ...subStores,
  api: publicApi,
});
